import PropTypes from 'prop-types';
// material
import { visuallyHidden } from '@mui/utils';
import {
  Box,
  Checkbox,
  TableRow,
  TableCell,
  TableHead,
  TableSortLabel,
  tableCellClasses
} from '@mui/material';
// styling
import { StyledTableCell } from '../../../pages/Global/Styling';
// ----------------------------------------------------------------------

UserListHead.propTypes = {
  order: PropTypes.oneOf(['asc', 'desc']),
  orderBy: PropTypes.string,
  rowCount: PropTypes.number,
  headLabel: PropTypes.array,
  numSelected: PropTypes.number,
  onRequestSort: PropTypes.func,
  onSelectAllClick: PropTypes.func
};

export default function UserListHead({
  order,
  orderBy,
  rowCount,
  headLabel,
  numSelected,
  onRequestSort,
  onSelectAllClick,
  isCheckBox,
  disableBoxTrue,
  disableBoxFalse,
  parent
}) {
  const createSortHandler = (property) => {
    onRequestSort({}, property);
  };
  return (
    <TableHead>
      <TableRow>
        {isCheckBox && (
          <TableCell padding="checkbox">
            <Checkbox
              className={
                disableBoxTrue &&
                disableBoxFalse &&
                disableBoxTrue.length > 0 &&
                disableBoxFalse.length === 0
                  ? 'disabledDocument'
                  : 'enabledDocument'
              }
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
            />
          </TableCell>
        )}
        {headLabel
          // .filter((headCell) => headCell.label !== 'ACTION')
          .map((headCell) => (
            <StyledTableCell
              key={headCell.id}
              align={headCell.alignRight ? 'right' : 'left'}
              sortDirection={orderBy === headCell.id ? order : false}
              style={
                (parent === 'reports' ? { minWidth: '150px' } : {},
                (parent === 'sales' && headCell.id === 'leadId') ||
                headCell.label === 'Policy ID' ||
                (parent === 'aggrement' && headCell.label === 'Bank')
                  ? { paddingLeft: '25px' }
                  : {})
              }
            >
              <TableSortLabel
                hideSortIcon
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={(e) => createSortHandler(headCell.id)}
              >
                {headCell.label === 'ACTION' ? headCell.label : headCell.label}
                {orderBy === headCell.id ? (
                  <Box sx={{ ...visuallyHidden }}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </TableSortLabel>
            </StyledTableCell>
          ))}
      </TableRow>
    </TableHead>
  );
}
